import InfiniteList from "@pathwright/ui/src/components/infinite/InfiniteList"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import { useObserveSizeContext } from "@pathwright/ui/src/components/observers/ObserveSizeContext"
import { useScreensizeContext } from "@pathwright/ui/src/components/ui/Screensize"
import { ConnectStores } from "lib/core/store"
import "./MemberList.css"
import MemberListEmpty from "./MemberListEmpty"
import MemberListItem from "./MemberListItem"
import MemberListSearch from "./MemberListSearch"
import MemberListSort from "./MemberListSort"
import MemberTypeFilter from "./MemberTypeFilter"

const MemberList = ({
  members,
  members_loaded,
  members_loading,
  loadMoreMembers,
  hasMoreMembers,
  showSearch,
  showList,
  filterRoleType,
  role_type
}) => {
  const screensize = useScreensizeContext()
  const { useSizeRef, getRectValue } = useObserveSizeContext()
  const sizeRefName = "MemberList__wrapper"
  const sizeRef = useSizeRef(sizeRefName)
  // distance from top of viewport to top of the .MemberList__wrapper element
  const memberListWrapperTop = getRectValue(`${sizeRefName}.top`)

  const renderEmpty = () => {
    if (!members_loaded) return renderLoading()
    return <MemberListEmpty />
  }

  const renderLoading = () => {
    return <LoadingCircle />
  }

  const renderRow = (row) => {
    const member = members[row.index]
    const offset = 3
    return (
      <MemberListItem
        key={member.id}
        member={member}
        style={row.style}
        controlsPlacement={
          members.length > offset &&
          // alter the palcement of the dropdown for the last 2 items
          row.index > members.length - offset - 1
            ? "top"
            : "bottom"
        }
      />
    )
  }

  const maxHeight = members && members.length > 5 && members.length * 50
  // space 50px above bottom of viewport if on non-mobile screensize
  const offset = screensize === "sm" ? 0 : 50
  const height = memberListWrapperTop
    ? `calc(100vh - ${memberListWrapperTop + offset}px)`
    : undefined

  return (
    <div className="MemberList">
      <div className="MemberList__controls">
        {showSearch && <MemberListSearch />}
        {showSearch && (
          <MemberTypeFilter onFilter={filterRoleType} role={role_type} />
        )}
        {showSearch && <MemberListSort />}
      </div>
      {showList ? (
        <div
          className="MemberList__wrapper"
          style={{ maxHeight, height }}
          ref={sizeRef}
        >
          <InfiniteList
            items={members || []}
            rowHeight={50}
            noRowsHeight={300}
            overscanRowCount={10}
            hasNextPage={hasMoreMembers()}
            loadNextPage={() => loadMoreMembers().promise}
            isNextPageLoading={members_loading}
            noRowsRenderer={renderEmpty}
            rowRenderer={renderRow}
          />
        </div>
      ) : (
        <LoadingCircle />
      )}
    </div>
  )
}

MemberList.displayName = "MemberList"

const mapStateToProps = (state, ownProps) => {
  const { offering } = state.resourceStore.state
  const {
    members,
    members_loading,
    members_loaded,
    members_query,
    members_pagination,
    role_type
  } = state.memberStore.state
  const { loadMoreMembers, filterRoleType } = state.memberStore.action
  const { hasMoreMembers } = state.memberStore.request

  const showSearch = true //(members && members.length > 1) || role_type
  const showTitle =
    (offering && members) || (offering && members_query.length > 0)
  const showList = !(members_loading && !members) || members_query.length > 0

  return _.assign(
    {},
    {
      members,
      offering,
      members_query,
      members_loaded,
      members_loading,
      loadMoreMembers,
      hasMoreMembers,
      showSearch,
      showTitle,
      showList,
      filterRoleType,
      role_type
    },
    ownProps
  )
}

const stores = [
  { store: "resource", watch: ["offering"] },
  {
    store: "member",
    watch: [
      "members",
      "members_loading",
      "members_loaded",
      "members_pagination",
      "members_query",
      "role_type"
    ]
  }
]

export default ConnectStores(MemberList, stores, {}, mapStateToProps)
